<template>
    

    <div class="home">
      <!-- 右上角两个小按钮：和 DashboardRightAlarm 完全同款（全屏在左，返回主页在右，两者贴得很近） -->
      <div class="hdr-tools">
        <!-- 全屏 / 退出全屏：整个主页铺满屏幕 -->
        <button
          class="fs-btn"
          type="button"
          :title="fs ? '退出全屏（Esc）' : '全屏显示'"
          :aria-label="fs ? '退出全屏' : '全屏显示'"
          @click="toggleFs"
        >
          <svg v-if="!fs" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-else viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <!-- 返回主页：最右侧，仅一个实心蓝色小房子 -->
        <button class="back-btn" type="button" title="返回主页" @click="backHome">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M11.34 3.28a1 1 0 0 1 1.32 0l8.4 7.36a1 1 0 0 1-.66 1.75H19.4v7.4a1.4 1.4 0 0 1-1.4 1.4h-3.4v-5.6h-5.2v5.6H6a1.4 1.4 0 0 1-1.4-1.4v-7.4H3.6a1 1 0 0 1-.66-1.75z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>
      
      <div class="box-left">
        <div class="left-top">
          <div class="current-num">
            <div>当前车间</div>
            <p>系统制造部</p>
          </div>
        </div>
        
        <div class="left-center">
          <div class="title-box">
            <div>正在进行的任务 {{ currentTask.合同号 }}</div>
          </div>
          <div class="left-bottom">
            <div class="left-bottom-box-table">
                <el-table
                  ref="xjwTableLeft"
                  :data="currentTaskTableData"
                  :height="tableLeftHeight"
                  style="width: 100%"
                  :row-class-name="tableRowClassName"
                >
                  <el-table-column prop="代码" label="代码" min-width="80">
                  </el-table-column>
                  <el-table-column prop="名称" label="名称" min-width="100">
                  </el-table-column>
                  <el-table-column prop="在途" label="在途" min-width="50">
                  </el-table-column>
                  <el-table-column prop="已领" label="已领" min-width="50">
                  </el-table-column>
                  <el-table-column prop="库存" label="库存" min-width="50">
                  </el-table-column>
                  <el-table-column prop="现场缺料" label="缺料" min-width="60"> </el-table-column>
                  <!-- <el-table-column prop="领料标志" label="领料标志"> </el-table-column> -->
                </el-table>
              </div>
          </div>
        </div>
        <!-- <div class="left-bottom">
         
        </div> -->
      </div>
      <div class="box-center">
        <div class="center-top">
          <h1>车间制造任务看板</h1>
        </div>
        <div class="center-center">
          <!-- <Weather></Weather> -->
          <div class="center-center-left">
            <div class="center-center-left-title">总下达任务数</div>
            <div class="center-center-left-num">{{ totalNum }}</div>
          </div>
          <div class="weather-box">
            <i class="top"></i><i class="bottom"></i>
            <div class="data">
              <p class="time" id="time">{{ nowTime }}</p>
              <div class="timeData">
                <span id="date" class="date">{{ nowDate }}</span>
                <span id="date" class="date">星期{{ weekText[nowWeek] }}</span>
              </div>
            </div>
            <div class="weather-box-line"></div>
            <div class="weather">
              <!-- <Weather></Weather> -->
              <img
                id="weatherImg"
                src="~@/assets/images/weather/weather_img01.png"
                alt=""
              />
              <div id="weather">
                <p class="active">{{ weatherData.text }}</p>
                <p>{{ weatherData.temp }}℃</p>
                <p>重庆市</p>
              </div>
            </div>
          </div>

          <!-- <img src="~@/assets/images/line_bg.png" alt=""> -->
        </div>
        <div class="center-bottom">
          <div class="center-bottom-box-table">
            <el-table
              ref="xjwTableCenter"
              :data="tableData"
              :height="tableHeight"
              style="width: 100%"
              row-class-name='row-white'

            >
              <el-table-column prop="任务号" label="任务号" min-width="120">
              </el-table-column>
              <el-table-column prop="回复交期" label="回复交期" min-width="90">
              </el-table-column>
              <!-- <el-table-column prop="开工日期" label="开工日期">
              </el-table-column> -->
              <el-table-column prop="合同号" label="合同号" min-width="130">
              </el-table-column>
              <el-table-column prop="型号" label="型号" min-width="180" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="装配" label="装配人" min-width="70">
              </el-table-column>
              <el-table-column prop="设计" label="设计" min-width="60"> 
              </el-table-column>
              <el-table-column label="进度" min-width="70" align="center">
                <template slot-scope="scope">
                  <span
                    class="status-dot"
                    :class="getProgressClass(scope.row.设计进度)"
                  ></span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

    </div>
  
</template>

<script>
import { convertDateFormat } from '@/utils/tools.js';
import { apiMain } from '@/api/mainapi.js';
import './js/layer/laydate/laydate.js';
import Weather from './weather.vue';
import * as echarts from 'echarts';
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
} from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import axios from 'axios';
import UserInfoUtils from '@/utils/userInfoUtils.js';
/* 全屏开关：优先原生 Fullscreen API，不支持时自动退回铺满视口（与工位看板共用同一份实现） */
import { toggleFullscreen, onFullscreenChange } from './js/fullscreen.js';
export default {
  components: {
    Weather
  },

  name: 'home',
  props: {
    msg: String
  },
  data() {
    return {
      currentTaskIndex: 1,
      currentTask: {},
      currentTaskTableData: [],
      timer: null,
      leftTimer: null,
      centerTimer: null,
      totalNum: 0,
      tableData: [],
      tableHeight: 400,
      tableLeftHeight: 400,
      myChart: null,
      nowTime: '',
      nowDate: '',
      nowWeek: '',
      weatherData: {},
      weekText: ['日', '一', '二', '三', '四', '五', '六'],
      option: {
        title: {
          text: '本月任务完成情况',
          textStyle: {
            color: '#fff'
          },
          x: 'center',
          y: '25px',
          subtextStyle: {
            align: 'center',
            ontSize: '30px'
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['数据一', '数据2', '数据3', '数据4', '数据5'],
          x: 'center',
          y: 'bottom',
          padding: [0, 20, 20, 0],
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '15%',
          top: '20%',
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '数据一',
            type: 'line',
            stack: 'Total',
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '数据2',
            type: 'line',
            stack: 'Total',
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: '数据3',
            type: 'line',
            stack: 'Total',
            data: [150, 232, 201, 154, 190, 330, 410]
          },
          {
            name: '数据4',
            type: 'line',
            stack: 'Total',
            data: [320, 332, 301, 334, 390, 330, 320]
          },
          {
            name: '数据5',
            type: 'line',
            stack: 'Total',
            data: [820, 932, 901, 934, 1290, 1330, 1320]
          }
        ]
      },
      fs: false, // 是否处于全屏（按钮图标 / 提示跟着切）
    };
  },
  mounted() {
    this.getNowTime();
    this.getWeather();
    this.$nextTick(() => {
      echarts.use([
        TitleComponent,
        ToolboxComponent,
        TooltipComponent,
        GridComponent,
        LegendComponent,
        LineChart,
        CanvasRenderer,
        UniversalTransition
      ]);
      this.initEcharts();
      this.myChart.setOption(this.option);
    });
    this.getDataList();
    this.calcTableHeight();
    window.addEventListener('resize', this.calcTableHeight);
  this.$nextTick(() => {
    const left = this.$refs.xjwTableLeft && this.$refs.xjwTableLeft.bodyWrapper;
    const center = this.$refs.xjwTableCenter && this.$refs.xjwTableCenter.bodyWrapper;

    if (left) this.autoCycle(left);
    if (center) this.autoCycle(center);
  });
    // 原生全屏按 ESC / F11 退出时不经过按钮，靠这个把按钮图标同步回来
    this.offFsChange = onFullscreenChange((on) => { this.fs = on; });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight);
    if (this.offFsChange) this.offFsChange(); // 摘掉全屏状态监听
  },
  methods: {
  /**
   * 根据设计进度返回圆点样式类
   */
getProgressClass(val) {
  if (!val) return 'dot-gray';

  // ✅ 去掉 %, 逗号, 空格，再转数字
  const num = Number(
    val.toString()
      .replace(/%/g, '')
      .replace(/,/g, '')
      .trim()
  );

  if (isNaN(num)) return 'dot-gray';

  if (num >= 100) return 'dot-green';
  if (num >= 80) return 'dot-yellow';
  if (num >= 50) return 'dot-orange';
  return 'dot-red';
},

    /**
    * 根据“领料标志”设置行颜色
    */
    tableRowClassName({ row }) {
      const flag = row.领料标志;

      if (!flag) return '';

      if (flag.includes('发')) {
        return 'row-orange';
      }

      if (flag.includes('缺料')) {
        return 'row-red';
      }

      if (flag.includes('齐料')) {
        return 'row-white';
      }

      return '';
    },

    /**
     * 点击跳转回首页
     */
     backHome() {
      // 返回主页：按权限决定（有项目管理权限→项目主页，否则→合同主页），避免跳转到无权限的项目页
      this.$router.push(UserInfoUtils.getDefaultHomeRoute());
     },
    /* ---------- 全屏 ---------- */
    // 整个主页铺满屏幕：优先原生全屏，不支持时自动退回「铺满视口」
    toggleFs() {
      toggleFullscreen(this.$el, (on) => { this.fs = on; });
    },
    /**
     * 定期更新当前任务详情,每隔15秒更新一次
     */
    updateTaskDetail() {
      setInterval(() => {
        const obj= this.tableData[this.currentTaskIndex];
      this.currentTask = obj;
      this.currentTaskIndex = this.currentTaskIndex < this.tableData.length - 1? this.currentTaskIndex + 1 : 0;
        this.getTaskDetail(obj);
      }, 15000);
    },
    getTaskDetail(data) {
      if(!data){
        return;
      }
      const params = {
        Type: 'ICMO',
        msg: data.任务号
      };
      apiMain(params).then((res) => {
        console.log("任务详情",res);
        if (res.data.data.length) {
          this.currentTaskTableData = res.data.data;
        }
      });
      
      // this.autoCycleLeft();
    },

autoCycle(wrapper) {
  if (!wrapper) return;

  clearInterval(wrapper._cycleTimer);

  wrapper._cycleTimer = setInterval(() => {
    wrapper.scrollTop += 1;

    if (wrapper.scrollTop + wrapper.clientHeight >= wrapper.scrollHeight - 1) {
      wrapper.scrollTop = 0;
    }
  }, 50);
},

    autoCycleCenter() {
      clearInterval(this.centerTimer);
      const wrapper = this.$refs.xjwTableCenter.bodyWrapper;
      if (!wrapper) return;

      this.centerTimer = setInterval(() => {
        wrapper.scrollTop += 1;
        if (wrapper.clientHeight + wrapper.scrollTop >= wrapper.scrollHeight) {
          wrapper.scrollTop = wrapper.scrollTop - wrapper.scrollHeight / 2;
        }
      }, 50);
    },

    autoCycleLeft() {
      // this.leftTimer = null;
      //每次更新任务详情时，清除定时器
      clearInterval(this.leftTimer);
      //拿到相关元素
      const wrapper = this.$refs.xjwTableLeft.bodyWrapper;
      if (!wrapper) return;

      this.leftTimer = setInterval(() => {
        wrapper.scrollTop += 1;
        if (wrapper.clientHeight + wrapper.scrollTop >= wrapper.scrollHeight) {
          wrapper.scrollTop = wrapper.scrollTop - wrapper.scrollHeight / 2;
        }
      }, 50);
    },

    async getDataList() {
      const params = {
        Type: 'ICMO',
        ProjectName: '下达'
      };
      const res = await apiMain(params);
      console.log('下达', res);
      // this.tableData = res.data.data;
      if (res.data.data.length) {
        this.totalNum = res.data.data.length;
        this.tableData = res.data.data;
        this.tableData.forEach((item) => {
          if (item.回复交期) {
            item.回复交期 = convertDateFormat(item.回复交期);
          }
          if (item.开工日期) {
            item.开工日期 = convertDateFormat(item.开工日期);
          }
        });
        this.currentTask = this.tableData[0];
        this.getTaskDetail(this.tableData[0]);
        this.updateTaskDetail()
      }
    },
    initEcharts() {
      let chartDom = document.getElementById('main');
      this.myChart = echarts.init(chartDom);
    },
    getWeather() {
      let url =
        'https://devapi.qweather.com/v7/weather/now?location=101040100&key=65ab626aac4c41d493ddaa9cccb7592b';
      axios(url).then((res) => {
        let { code, now } = res.data;
        if (code == '200') {
          console.log(now);
          this.weatherData = now;
        }
      });
    },
    getNowTime() {
      let speed = 1000;
      let that = this;
      let theNowTime = function () {
        that.nowTime = that.timeNumber();
        that.nowDate = that.getDate();
        that.nowWeek = that.getWeek();
      };
      setInterval(theNowTime, speed);
    },
    timeNumber() {
      let today = new Date();
      // let date = today.getFullYear() + '-' + this.twoDigits(today.getMonth() + 1) + '-' + this.twoDigits(today.getDate())
      let time =
        this.twoDigits(today.getHours()) +
        ':' +
        this.twoDigits(today.getMinutes()) +
        ':' +
        this.twoDigits(today.getSeconds());
      return time;
    },
    getDate() {
      let today = new Date();
      let date =
        today.getFullYear() +
        '/' +
        this.twoDigits(today.getMonth() + 1) +
        '/' +
        this.twoDigits(today.getDate());
      return date;
    },
    getWeek() {
      let today = new Date();
      let date = today.getDay();
      return date;
    },
    calcTableHeight() {
      this.$nextTick(() => {
        const centerBox = this.$el.querySelector('.center-bottom-box-table');
        const leftBox = this.$el.querySelector('.left-bottom-box-table');
        if (centerBox) {
          this.tableHeight = centerBox.clientHeight;
        }
        if (leftBox) {
          this.tableLeftHeight = leftBox.clientHeight;
        }
      });
    },
    twoDigits(val) {
      if (val < 10) return '0' + val;
      return val;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
  width: 100%;
  height: 100vh;
  background: url(~@/assets/images/index_bg.png) left top no-repeat;
  background-size: 100% 100%;
  display: flex;
  outline: none;
  overflow: hidden;
  position: relative;
}

/* ============ 右上角按钮组：全屏 + 返回主页（与 DashboardRightAlarm 完全同款） ============ */
.hdr-tools {
  position: absolute;
  top: 10px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 2px; /* 两个按钮之间只留一点点缝 */
  z-index: 999;
}

/* 返回主页按钮：无边框无底色，仅一个小房子图标 */
.back-btn {
  flex: 0 0 auto;
  width: 30px; height: 30px;
  display: grid; place-items: center;
  padding: 0; border: 0; border-radius: 8px;
  color: #0595EB; background: transparent;
  cursor: pointer; font-family: inherit;
  transition: color .15s, background .15s, transform .15s;
}
.back-btn svg { width: 18px; height: 18px; }
.back-btn:hover { color: #ffffff; background: rgba(5, 149, 235, .32); transform: translateY(-1px); }
.back-btn:active { transform: translateY(0); }

/* 全屏按钮：与「返回主页」同尺寸同观感，放在它左边 */
.fs-btn {
  flex: 0 0 auto;
  width: 30px; height: 30px;
  display: grid; place-items: center;
  padding: 0; border: 0; border-radius: 8px;
  color: #0595EB; background: transparent;
  cursor: pointer; font-family: inherit;
  transition: color .15s, background .15s, transform .15s;
}
.fs-btn svg { width: 18px; height: 18px; }
.fs-btn:hover { color: #ffffff; background: rgba(5, 149, 235, .32); transform: translateY(-1px); }
.fs-btn:active { transform: translateY(0); }
/* 原生全屏 / 兜底伪全屏时都要铺满整个屏幕 */
.home:fullscreen { width: 100vw; height: 100vh; }
.home.is-fs {
  position: fixed !important; inset: 0; z-index: 1200;
  width: 100vw; height: 100vh;
}


/* =====================车间部门部分============================= */
.box-left {
  width: 30%;
  height: 100%;
  background: url(~@/assets/images/line_img.png) top right repeat-y;
}
.left-top {
  width: 100%;
  height: 27%;
  position: relative;
}
.left-top > .current-num {
  width: 90%;
  height: 70%;
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  /* 车间部门背景 */
  background: url(~@/assets/images/border_bg01.png) top left no-repeat;
  background-size: 100% 100%;
}
.current-num > div {
  font-size: clamp(0.9rem, 2vw, 2.1rem);
  margin-top: 20px;
  width: 100%;
  text-align: center;
  /* background: url(~@/assets/images/title_bg01.png) center center no-repeat; */
  color: #00aeff;
  /* background-size: 1.8rem 0.25rem; */
  font-weight: 900;
}
.current-num > p {
  font-size: clamp(1.8rem, 3vw, 3.5rem);
  text-align: center;
  color: white;
  /* 车间和部门的间距 */
  margin: 15px; 
}



/* =====================左侧合同部分============================= */
.left-center {
  width: 100%;
  height: 66%;
  position: relative;
}
.title-box {
  width: 90%;
  height: 10%;
  background: url(~@/assets/images/box_title.png) top left no-repeat;
  background-size: 100% 100%;
  margin: auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  position: relative;
}
.title-box > div {
  font-weight: 700;
  color: #00aeff;
  font-size: clamp(0.9rem, 1.5vw, 2.1rem);
  text-align: center;
}



/* =====================右侧看板标题部分============================= */
.box-center {
  width: 70%;
  height: 100%;
  /*    background: green;*/
  display: flex;
  flex-direction: column;
  align-items: center;
}

.center-top {
  width: 100%;
  height: 8.8%;
  position: relative;
  top: 0;
  left: 0;
  background: url(~@/assets/images/title_border.png) bottom center no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
}

.center-top > h1 {
  color: #00aeff;
  font-size: clamp(1.8rem, 3vw, 2.8rem);
  font-weight: 900;
  letter-spacing: 5px;
}

/* =====================右侧下达任务数部分============================= */
.center-center {
  width: 90%;
  height: 25%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.center-center-left {
  width: 35%;
  height: 80%;
  position: relative;
  background: url(~@/assets/images/border_bg01.png) top center no-repeat;
  background-size: 100% 100%;
}
.center-center-left-title {
  font-size: clamp(0.9rem, 2vw, 2.1rem);
  color: #00aeff;
  font-weight: 700;
  margin-top: 20px;
}
.center-center-left-num {
  font-size: clamp(1.8rem, 4vw, 4.5rem);
  color: #cdddf7;
  margin-top: 30px;
  font-weight: 700;

}

/* =====================右侧时间天气部分============================= */
.weather-box {
  width: 53%;
  height: 80%;
  display: flex;
  position: relative;
  flex-flow: row nowrap;
  background: url(~@/assets/images/border_bg01.png) top center no-repeat;
  background-size: 100% 100%;
  justify-content: space-around;
  align-items: center;
}
.weather-box .weather-box-line {
  width: 2px;
  background: #00aeff;

  height: 75%;
}

.data > p {
  margin: 0 5px;
  color: #cdddf7;
  text-align: center;
  margin: 0;
}

.data > p > span {
  margin: 0 5px;
}

.data > p.time {
  font-size: clamp(1.8rem, 3vw, 3.5rem);
}

.weather-box > .weather {

  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
  /* margin-left: 10px; */
  margin-right: 10px;
  font-size: clamp(0.9rem, 2vw, 2.1rem);
}

.weather > img {
  height: 100%;
}

.weather > div {
  height: 100%;
}

.weather > div > p {
  margin: 5px;
  color: #cdddf7;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}
.weather > div > p.active {
  color: white;
}
.data > p.time[data-v-f2994dc4] {
  font-size: 50px;
  margin: 5px;
}
.timeData {
  color: #ffffff;
  display: flex;
  justify-content: space-around;
  font-size: clamp(0.9rem, 2vw, 3.1rem);
  align-items: center;
}
.date {
  margin-bottom: 5px;
}

/* =====================左侧下拉表格部分============================= */
.left-bottom{
  width: 95%;
  height: 92%;
  position: relative;
  background-size: 100% 100%;
  border: 2px solid #00aeff;
}

.left-bottom-box-table {
  width: 100%;
  height: 100%;
}

/* ===================== 领料状态行颜色 ===================== */

::v-deep .el-table .row-orange {
  /* background-color: rgba(255, 165, 0, 0.25) !important; */
  color: #ffa500 !important;
}

::v-deep .el-table .row-red {
  /* background-color: rgba(255, 0, 0, 0.25) !important; */
  color: #ff4d4f !important;
}

::v-deep .el-table .row-white {
  /* background-color: rgba(255, 255, 255, 0.08) !important; */
  color: #ffffff !important;
}


/* =====================右侧下拉表格部分============================= */
.center-bottom {
  /* background: #142030d6; */
  width: 95%;
  height: 60%;
  position: relative;
  /* background: url(~@/assets/images/border_bg01.png) top center no-repeat; */
  background-size: 100% 100%;
  border: 2px solid #00aeff;
}

.center-bottom-box-table {
  width: 100%;
  height: 100%;
}

.weather-box {
  position: relative;
  overflow: hidden;
}

/* ===================== 设计进度圆点 ===================== */

.status-dot {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

/* 绿色 */
.dot-green {
  background-color: #52c41a;
  box-shadow: 0 0 6px #52c41a;
}

/* 黄色 */
.dot-yellow {
  background-color: #faad14;
  box-shadow: 0 0 6px #faad14;
}

/* 橙色 */
.dot-orange {
  background-color: #ff7a45;
  box-shadow: 0 0 6px #ff7a45;
}

/* 红色 */
.dot-red {
  background-color: #f5222d;
  box-shadow: 0 0 6px #f5222d;
}

/* 空数据 */
.dot-gray {
  background-color: #8c8c8c;
}




::v-deep .el-form-item {
  margin: 0 5px !important;
}
::v-deep .el-table,
.el-table__expanded-cell {
  padding: 20px !important;
  background-color: transparent !important;
  font-size: clamp(0.9rem, 1.2vw, 2.8rem) !important;
}
::v-deep .el-table th {
  background-color: transparent !important;
  border-bottom: 1px solid #00aeff !important;
  /* color: #fefefe !important; */
}
::v-deep .el-table tr {
  pointer-events: none;
  background-color: transparent !important;
}
::v-deep .el-table__row :hover {
  /* background-color: #74efff !important; */
  pointer-events: none;
}
::v-deep .el-table--enable-row-transition .el-table__body td,
::v-deep .el-table .cell {
  background-color: transparent !important;
  /* color: rgba(255, 255, 255, 1) !important; */
  border: none !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}


::v-deep .el-table th > .cell {
  /* color: rgba(254, 254, 254, 1) !important; */
  font-weight: 700 !important;
}
.el-table::before {
  left: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 0px !important;
}

/* ::v-deep .el-form-item__label {
  color: white !important;
} */


/* =====================表格滚动条部分============================= */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  /*width: 0;表格滚动条宽度为0隐藏*/
  width: 5px;
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 1px;
  height: 58px;
  background: rgba(255, 255, 255, 0.359);
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(241, 240, 245, 0.429);
  border-radius: 3px;
  background: #ffffff25;
}

</style>
